import React, {useContext,useState} from 'react';
import Toolbar, {Item} from 'devextreme-react/toolbar';
import Button from 'devextreme-react/button';
import MenuPanel from '../menu-panel/menu-panel';
import UserPanel from '../user-panel/user-panel';
import './header.scss';
import {Template} from 'devextreme-react/core/template';
import {NavbarContext} from '../../contexts/top-navigation';
import { Popover } from 'devextreme-react/popover';
import shipslandLogo from '../../assets/Shipsland-Logo.jpg';

export default({menuToggleEnabled, title, toggleMenu, box}) => {
    const menu = useContext(NavbarContext);
    const [isNotifButtonOnClick, setIsNotifButtonOnClick] = useState(false);

    const notifButtonOnClick= () =>{
        if(!isNotifButtonOnClick)
            setIsNotifButtonOnClick(true)
        else
            setIsNotifButtonOnClick(false)
    }

    return (
        <header className={'header-component'}>

            <Toolbar className={'header-toolbar'}>
                <Item
                    visible={menuToggleEnabled}
                    location={'before'}
                    widget={'dxButton'}
                    cssClass={'menu-button'}>
                    <Button icon="menu" stylingMode="text" onClick={toggleMenu}/>
                </Item>
                <Item
                    location={'before'}
                    cssClass={'header-title'}>
                        <img alt={'header-logo'} className={'header-logo'} src={shipslandLogo}/>
                </Item>
                <Item
                    location={'Before'}
                    locateInMenu={'auto'}
                    menuItemTemplate={'MenuPanelTemplate'}>
                    <MenuPanel/>
                </Item>
                <Item location={'after'} locateInMenu={'auto'}>
                    <Button stylingMode={'text'} className={'bell-notif'} onClick={notifButtonOnClick}>
                        <span id={'notification-badge'} className="fa-stack fa-1x has-badge" data-count="0">
                            <i className="fa fa-bell"></i>
                        </span>
                    </Button>
                </Item>
                <Item
                    className="icon-menu"
                    location={'after'}
                    locateInMenu={'auto'}
                    menuItemTemplate={'userPanelTemplate'}>
                    <Button
                        className={'user-button authorization'}
                        width={50}
                        height={'100%'}
                        stylingMode={'text'}>
                        <UserPanel menuMode={'context'}/>
                    </Button>
                </Item>
                <Template name={'userPanelTemplate'}>
                    <UserPanel menuMode={'list'}/>
                </Template>
                <Template name={'MenuPanelTemplate'}>
                    <MenuPanel menuMode={'list'}/>
                </Template>
            </Toolbar>
            <Popover
              target="#notification-badge"
              position="bottom"
              width={300}
              visible={isNotifButtonOnClick}
              onHiding={()=>{setIsNotifButtonOnClick(false)}}
              closeOnOutsideClick={true}
            >
                no notification to display
            </Popover>
        </header>
        
    )
};
